export default __webpack_public_path__ + "static/media/phone.93b1cab7.svg";